import { Component, OnInit, Input } from '@angular/core';
import { makeStateKey, TransferState } from '@angular/platform-browser';
import { CookieService } from 'ngx-cookie-service';
import { HomeService } from 'src/services/home/home.service';
const getWorks = makeStateKey('getWorks');

@Component({
  selector: 'our-portfolio',
  templateUrl: './our-portfolio.component.html',
  styleUrls: ['./our-portfolio.component.css']
})

export class OurPortfolioComponent implements OnInit 
{
  
  works: any;

  constructor(
    private service: HomeService,    
    private state: TransferState,
    private cookie_s: CookieService
    ){}

  async ngOnInit(): Promise<void> {
    await this.getDate()
  }

  setIndex(i) {
    this.cookie_s.set('projectIndex', i, undefined, '/' );
  }

  async getDate() {


    const store = this.state.get(getWorks, null) as any;
    console.log(store)

  if (store == null) {
  await this.service.getWorks().subscribe(res=>{
this.state.set(getWorks,res);

this.works = res?.andorid;  
console.log(this.works)

    });;

      
      }
 
  
    else {
      this.works = store.andorid
    }
  };
}
